import { render, staticRenderFns } from "./PromotionProducts.vue?vue&type=template&id=8e5ba48a&scoped=true&"
import script from "./PromotionProducts.vue?vue&type=script&lang=js&"
export * from "./PromotionProducts.vue?vue&type=script&lang=js&"
import style0 from "./PromotionProducts.vue?vue&type=style&index=0&id=8e5ba48a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e5ba48a",
  null
  
)

export default component.exports